import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from './local-storage.service';
import { ROLE_CONFIG } from '../constants/constant';
import { KeycloakService } from '@inoventoryapps/keycloak-angular';
import { UserDetails } from '../models/keycloak.model';
@Injectable({
    providedIn: 'root'
})
export class GlobalService {
    public roleConfig: any = ROLE_CONFIG
    private currentUserDetails: UserDetails | null = null;
    private readonly selectedRoleQueryParam = 'roleContext';
    constructor(private http: HttpClient, private ls: LocalStorageService, private keycloakService: KeycloakService) { }
    permissionUrl = environment.permission ;
    async getUserInfo() {
    // let url = `${environment.keycloak.issuer}/realms/${environment.keycloak.realm}/protocol/openid-connect/userinfo`;
    // let url = environment.userinfo
    // return this.http.get(url, { observe: 'response' }).pipe(
    //   map((response: any) => {
    //     return response.body;
    //   }),
    //   catchError((error) => {
    //     return throwError(error);
    //   })
    // );
        return await this.keycloakService.loadUserInfo()

    }

    getUserProfileImage (): Observable<string> {
        return this.http.get(environment.keycloakImageUrl, { responseType: 'text' });
    }
 

    // async setPermission(id: any, payload: any) {
    //   try {

    //     // return
    //     let res: any = await this.http.post(environment.permission + id, payload).toPromise()
    //   } catch (error) {
    //     throwError
    //   }
    // }
    //  getPermission(id: any): Observable<ProfileReviewResponse> {
    //          return this.http.get<ProfileReviewResponse>(`${environment.profileUrl}${id}`);
    //      }
    getPermission(params:any){
        return this.http.get<any>(`${this.permissionUrl}${params}`);
    }


    // getUsesrInfo() {
    //   // let url = `${environment.keycloak.issuer}/realms/${environment.keycloak.realm}/protocol/openid-connect/userinfo`;
    //   let url = environment.userinfo
    //   // return 
    //   this.http.get(url).subscribe(res => {
    //   })
    // 
    // }

    getUserRole() {
        return (this.currentUserDetails as (UserDetails & { activeRole?: string }) | null)?.activeRole || this.ls.get('role')
    }

    getUserDetails() {
        if (this.currentUserDetails) {
            return this.currentUserDetails;
        }

        const info = this.ls.get<UserDetails>('userDetails');
        if (info) {
            this.currentUserDetails = info;
        }
        return info;
    }

    setUserDetails(details: UserDetails | null) {
        this.currentUserDetails = details;

        if (!details) {
            this.ls.remove('userDetails');
            this.ls.remove('role');
            this.ls.remove('verticle');
            this.ls.remove('fullUserRoleVerticle');
            return;
        }

        const scopedDetails = details as UserDetails & {
            activeRole?: string;
            activeRoleVerticle?: string;
            fullUserRoleVerticle?: string;
        };

        this.ls.set<UserDetails>('userDetails', details);
        this.ls.set('role', scopedDetails.activeRole || '');
        this.ls.set('verticle', scopedDetails.activeRoleVerticle || '');
        this.ls.set('fullUserRoleVerticle', scopedDetails.fullUserRoleVerticle || '');
    }

    clearSensitiveUserContext() {
        this.currentUserDetails = null;
        this.ls.remove('userDetails');
        this.ls.remove('role');
        this.ls.remove('verticle');
        this.ls.remove('fullUserRoleVerticle');
        this.ls.remove('selectedRoleWithGeo');
    }

    getSelectedRoleFromUrl(): string {
        if (typeof window === 'undefined') {
            return '';
        }

        return new URL(window.location.href).searchParams.get(this.selectedRoleQueryParam)?.trim() || '';
    }

    buildUrlWithSelectedRole(roleWithGeo: string): string {
        if (typeof window === 'undefined') {
            return '';
        }

        const url = new URL(window.location.href);

        if (roleWithGeo) {
            url.searchParams.set(this.selectedRoleQueryParam, roleWithGeo);
        } else {
            url.searchParams.delete(this.selectedRoleQueryParam);
        }

        return url.toString();
    }

    getUserType() {
        return (this.getUserDetails() as (UserDetails & { activeRole?: string }) | null)?.activeRole || this.ls.get('activeRole')
    }

    // {
    //   state_id: 'S-13',
    //   state_code: 15,
    //   state_name: 'KARNATAKA',
    //   district_id: 'D-15011',
    //   district_code: 1511,
    //   district_name: 'DAKSHINA KANNADA',
    //   block_id: 'B-150073',
    //   block_code: 1511001,
    //   block_name: 'BELTANGADI',
    // },
    async getGeoLocationAsync() {
        try {
            const response = await this.http.get(environment.geoMapCdnUrl).toPromise();
            this.GEO_LOCATION = response;
        } catch (error) {
        }
    }

    // public GEO_LOCATION: any = GEO_LOCATION
    public GEO_LOCATION: any;

    getGeoLocation(data: any = {}, role: any) {

        let userInfo = this.getUserDetails() as UserDetails | undefined;

        const normalize = (val: any) =>
            (val || '').toString().replace(/^[A-Z]-/, '');

        const explicitBlockId = normalize(data?.blockId);
        const explicitDistrictId = normalize(data?.districtId);
        const explicitStateId = normalize(data?.stateId);

        const storedBlockId = normalize(userInfo?.blockId);
        const storedDistrictId = normalize(userInfo?.districtId);
        const storedStateId = normalize(userInfo?.stateId);

        const normalizedRole = String(role || '').trim().toLowerCase();

        const blockId =
    normalizedRole === 'block'
        ? (explicitBlockId || storedBlockId)
        : explicitBlockId;

        const districtId =
    normalizedRole === 'district'
        ? (explicitDistrictId || storedDistrictId)
        : explicitDistrictId;

        const stateId =
    normalizedRole === 'state'
        ? (explicitStateId || storedStateId)
        : explicitStateId;

        let find: any = null;

        // =========================
        // ✅ BLOCK USER
        // =========================
        if (blockId) {

            find = this.GEO_LOCATION?.find((val: any) =>
                val?.block_id === `B-${blockId}` ||
      val?.block_id?.split('-')?.[1] === blockId
            );

            if (find) {
                return {
                    ...data,
                    blockId: find.block_id?.split('-')[1],
                    districtId: find.district_id?.split('-')[1],
                    stateId: find.state_id?.split('-')[1]
                };
            }
        }

        // =========================
        // ✅ DISTRICT USER
        // =========================
        if (districtId) {

            find = this.GEO_LOCATION?.find((val: any) =>
                val?.district_id === `D-${districtId}` ||
      val?.district_id?.split('-')?.[1] === districtId
            );

            if (find) {
                return {
                    ...data,
                    districtId: find.district_id?.split('-')[1],
                    stateId: find.state_id?.split('-')[1],
                    blockId: '' // 🔥 IMPORTANT: DO NOT SHOW BLOCK
                };
            }
        }

        // =========================
        // ✅ STATE USER
        // =========================
        if (stateId) {

            find = this.GEO_LOCATION?.find((val: any) =>
                val?.state_id === `S-${stateId}` ||
      val?.state_id?.split('-')?.[1] === stateId
            );

            if (find) {
                return {
                    ...data,
                    stateId: find.state_id?.split('-')[1],
                    districtId: '', // 🔥 CLEAR
                    blockId: ''     // 🔥 CLEAR
                };
            }
        }

        // =========================
        // ❌ FALLBACK
        // =========================

        return {};
    }

    setIdRespToRoleType(params: any) {
        let role: any = this.getUserRole()
        let userDetails: any = this.getUserDetails()
        if (role && userDetails?.activeRole) {
            if (userDetails.activeRole.includes('national')) {
                //do nothing
            } else if (userDetails.activeRole.includes('state')) {
                params.state = userDetails?.stateId
            } else if (userDetails.activeRole.includes('district')) {
                params.district = userDetails?.districtId
            } else if (userDetails.activeRole.includes('block')) {
                params.block = userDetails?.blockId
            }
        }
        return params
    }

    setCategory(params: any) {
        let userDetails: any = this.getUserDetails();
        if (!userDetails) {
            return params;
        }

        const selectedRole = userDetails?.fullUserRoleVerticle?.toLowerCase().trim();

        if (selectedRole === 'clf bookkeeper') {
            params['category'] = '';
        } else {
            params['category'] = [userDetails?.activeRoleVerticle];
        }

        params['state_id'] = [userDetails?.stateId];

        return params;
    }
    getCategory() {
        let userDetails: any = this.getUserDetails()
        return userDetails?.activeRoleVerticle
    }

    getFinancialYears(count: number): string[] {
        const currentYear = new Date().getFullYear();
        const financialYears: any = [];

        for (let i = (count < 0 ? count : 1); i <= (count > 0 ? count : 0); i++) {
            const startYear = currentYear - i;
            const endYear = startYear + 1;
            financialYears.push(`${startYear}-${endYear.toString()}`);
        }

        return count < 0 ? financialYears.reverse() : financialYears.reverse();
    }

    getCurrentFinancialYear(): string {
        const today = new Date();
        const currentYear = today.getFullYear();
        const month = today.getMonth();

        const financialYearStartMonth = 3; // April is month 3 (zero-based index)

        let financialYear: string;

        if (month <= financialYearStartMonth) {
            financialYear = (currentYear - 1) + "-" + currentYear.toString();
        } else {
            financialYear = currentYear + "-" + (currentYear + 1).toString();
        }

        return financialYear;
    }


    async download1(name: any, id: any) {
        const fileName = decodeURIComponent(name);
        const mimeType = this.getMimeType(fileName);

        const baseUrl = environment.downloadUrl; // 'https://stage-fdm.lokos.in/api/vault/cadre/v1/'
        const url = `${baseUrl}${id}/${fileName}`;

        try {
            const blob = await this.http.get(url, { responseType: 'blob' }).toPromise();
            if (!blob) throw new Error('No file received');

            const downloadUrl = URL.createObjectURL(new Blob([blob], { type: mimeType }));
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = fileName;
            a.click();
            URL.revokeObjectURL(downloadUrl);
        } catch (err) {
        }
    }

    getMimeType(fileName: string): string {
        return 'application/octet-stream'; // Accepts any file type
    }


    getImageFullUrl(url: string, type: string): Observable<Blob> {
        return this.http.get(url, { responseType: 'blob' }).pipe(
            map((res: Blob) => new Blob([res], { type }))
        );
    }
}

